import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_USER } from '@/util/roles';

export const routes = [
	{
		path: 'aggregations',
		meta: {
			requireAuth: true,
			title: 'Depot - Aggregations',
			breadcrumb: 'Aggregations',
			// Deliberately below the /depot baseline. Declared on the section so it
			// cascades to every child that sets none, which is all of them; a child
			// may still raise its own bar later without this fighting it.
			minRole: ROLE_USER,
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.AGGREGATIONS.OVERVIEW,
				component: () => {
					return import('@/views/depot/aggregations/Overview.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
			{
				path: 'search',
				name: ROUTE_NAMES.DEPOT.AGGREGATIONS.SEARCH,
				component: () => {
					return import('@/views/depot/aggregations/Search-Aggregations.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Search',
				},
			},
			{
				path: 'vs',
				name: ROUTE_NAMES.DEPOT.AGGREGATIONS.VS,
				component: () => {
					return import('@/views/depot/aggregations/VS-Aggregations.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'VS',
				},
			},
		],
	},
];
